import React from 'react';
import Icon from './Icon';

/**
 * Celebration Overlay Component
 * Single Responsibility: Displaying completion celebration
 */
const CelebrationOverlay = ({ 
  show, 
  congratulationsData, 
  currentLine, 
  openingName, 
  mistakes 
}) => {
  if (!show || !congratulationsData) return null;

  return (
    <div className="absolute inset-0 flex items-center justify-center z-50 p-4 bg-ink-950/40 backdrop-blur-[2px] rounded-xl">
      <div className="card max-w-sm w-full p-6 text-center border-brand-500/40 shadow-board">
        <div className="text-5xl mb-3" role="img" aria-label="Celebration">
          {congratulationsData.emoji}
        </div>
        <div className="text-xl font-extrabold text-white">{congratulationsData.title}</div>
        <div className="text-ink-300 text-sm mt-1">{congratulationsData.message}</div>

        {congratulationsData.bonuses.length > 0 && (
          <div className="flex flex-wrap justify-center gap-1.5 mt-4">
            {congratulationsData.bonuses.map((bonus, index) => (
              <span key={index} className="badge bg-amber-500/15 text-amber-300">
                {bonus.emoji} {bonus.bonus}
              </span>
            ))}
          </div>
        )}

        <div className="mt-4 grid grid-cols-2 gap-2 text-left">
          <div className="rounded-xl bg-ink-800 px-3 py-2">
            <div className="label mb-0.5">Line</div>
            <div className="text-sm font-semibold text-ink-100 truncate">{currentLine?.name || 'Variation'}</div>
          </div>
          <div className="rounded-xl bg-ink-800 px-3 py-2">
            <div className="label mb-0.5">Mistakes</div>
            <div className={`text-sm font-semibold flex items-center gap-1 ${mistakes === 0 ? 'text-brand-300' : 'text-ink-100'}`}>
              {mistakes === 0 ? <><Icon name="check" size={14} /> Perfect</> : mistakes}
            </div>
          </div>
        </div>

        {congratulationsData.tip && (
          <p className="text-ink-400 text-xs mt-4 pt-4 border-t border-ink-700 flex gap-2 text-left">
            <Icon name="lightbulb" size={14} className="mt-0.5 text-brand-400" /> {congratulationsData.tip}
          </p>
        )}
        <span className="sr-only">{openingName}</span>
      </div>
    </div>
  );
};

export default CelebrationOverlay;
